import {Component} from 'preact';
import cx from 'classnames';
import pathOr from 'ramda/src/pathOr';

const getFirstImageSource = pathOr( '/', [0, 'source'] );
const getSrcSets = ( images, width ) => {
    const sets = {};
    const imgSrc = getFirstImageSource( images );
    const img1x = `${imgSrc}?w=${width}`;
    const img2x = `${imgSrc}?w=${width * 2}`;
    sets.jpg = `${img1x}, ${img2x} 2x`;
    sets.webp = `${img1x}&fm=webp, ${img2x}&fm=webp 2x`;
    sets.fallback = img1x;

    return sets;
};

class ProductImage extends Component {
    static defaultProps = {
        images: [],
        width: 64,
        className: ''
    };

    constructor ( props ) {
        super( props );
        const srcSets = getSrcSets( props.images, props.width );
        this.state = {srcSets};
    }

    render () {
        const {srcSets} = this.state;
        const {kitName, width, className} = this.props;

        return (
            <picture>
                <source sizes={width} type="image/webp" data-srcset={srcSets.webp}/>
                <source sizes={width} data-srcset={srcSets.jpg}/>
                <img
                    key={`img:${this.state.srcSets.fallback}`}
                    sizes={width}
                    data-src={srcSets.fallback}
                    alt={kitName}
                    title={kitName}
                    className={cx( 'lazyload fade-up', className )}
                    data-sx-product-img/>
            </picture>
        );
    };
}

export default ProductImage;
